import { memo } from 'react'

import { cn } from '@/shared/lib/cn'
import { DislikeIconButton } from '@/shared/ui/dislike'
import { LikeIconButton } from '@/shared/ui/like'

import { useOfferCardFooter } from '../../model/useOfferCardFooter.ts'
import { OfferCardInnerProps } from '../../types/OfferCardInnerProps.ts'

interface OfferCardFooterProps extends OfferCardInnerProps {
	likeButtonClassName?: string
	dislikeButtonClassName?: string
	priceClassName?: string
}

/**
 * Component for show price, like and dislike buttons
 *
 * @author Ivan Shchedrovskyi
 */
export const OfferCardFooter = memo(
	({
		offer,
		className,
		likeButtonClassName,
		dislikeButtonClassName,
		priceClassName
	}: OfferCardFooterProps) => {
		const { price, onDislike, onLike, isDisliked, isLiked } =
			useOfferCardFooter(offer)

		return (
			<div className={cn('flex items-center justify-between pr-2', className)}>
				<div className="flex items-center">
					<LikeIconButton
						className={likeButtonClassName}
						data-wwt-id="offer-card__like-button--unique"
						isLiked={isLiked}
						onClick={onLike}
					/>

					<DislikeIconButton
						className={dislikeButtonClassName}
						onClick={onDislike}
						isDisliked={isDisliked}
						data-wwt-id="offer-card__dislike-button--unique"
					/>
				</div>

				<div
					className={cn('ts-3 text-gray-500', priceClassName)}
					title={price}
				>
					{price}
				</div>
			</div>
		)
	}
)

OfferCardFooter.displayName = 'OfferCardFooter'
